/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nav_CreditsInputs */

const en_settings_nav_credits = /** @type {(inputs: Settings_Nav_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const zh_settings_nav_credits = /** @type {(inputs: Settings_Nav_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`额度明细`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Settings_Nav_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_nav_credits = /** @type {((inputs?: Settings_Nav_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nav_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_nav_credits(inputs)
	return zh_settings_nav_credits(inputs)
});
export { settings_nav_credits as "settings.nav.credits" }